// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__AIxuh","insightsList":"newBusinessInsightsMenu_insightsList__1AC0C","active":"newBusinessInsightsMenu_active__3H0wn"};